import { Fragment } from "react"

import { Divider, Flex, Image, Typography } from "antd"

import Icon from "../../../Icon"
import { openHideLink } from "../../../Utils/utils"
import ButtonComponent from "../../Button"

const { Text } = Typography

export const AttachmentsList = ({ attachments, children, onDelete, preview }) => {
  const isDelete = !!onDelete
  if (!attachments?.length) return null

  return (
    <>
      {children}
      <Flex gap={8} vertical={true}>
        {attachments?.map((file, idx) => (
          <Fragment key={file?.file_name + idx}>
            <Flex gap={8} align="center" justify="space-between">
              <Flex gap={4}>
                {preview ? (
                  <Image
                    width={24}
                    height={24}
                    style={{ borderRadius: 4, minWidth: 24 }}
                    src={file?.file_url}
                    preview={{ src: file?.file_url }}
                  />
                ) : (
                  <Icon
                    type={
                      [".png", ".jpeg", ".jpg"].some((ext) => file?.file_name?.endsWith(ext))
                        ? "pictures"
                        : "document"
                    }
                    style={{ fontSize: 20, lineHeight: 1 }}
                  />
                )}
                <Flex gap={2} vertical={true}>
                  <Text>{file?.file_name}</Text>
                  <Text type="secondary" style={{ fontSize: 12, lineHeight: 1.5 }}>
                    ({(file?.["file_size"] / 1000).toFixed(0)}KB)
                  </Text>
                </Flex>
              </Flex>
              <Flex>
                <ButtonComponent
                  type="link"
                  shape="circle"
                  icon={<Icon type="eye" />}
                  onClick={() => openHideLink(file?.file_url, "_blank")}
                  className="flex center table-action-btn"
                  style={{ marginLeft: "auto" }}
                />

                {isDelete ? (
                  <ButtonComponent
                    type="link"
                    shape="circle"
                    icon={<Icon type="delete" />}
                    onClick={() => onDelete(file)}
                    className="flex center table-action-btn"
                    style={{ marginLeft: "auto" }}
                  />
                ) : (
                  <a
                    href={file.file_url}
                    download={true}
                    style={{ marginLeft: "auto" }}
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <Text type="secondary">
                      <Icon type={"arrow_inbox"} style={{ fontSize: 20, lineHeight: 1 }} />
                    </Text>
                  </a>
                )}
              </Flex>
            </Flex>
            <Divider style={{ margin: 0 }} />
          </Fragment>
        ))}
      </Flex>
    </>
  )
}
